import defaultErrorHandler from "actions/global/default-error-handler";
import { toast } from "react-toastify";

import {
  requestCreate,
  requestUpdate,
  requestDelete
} from "./requests";
import {
  SHARING_LOADING,
  SHARING_ERROR,

  SHARING_ADD,
  SHARING_UPDATE,
  SHARING_DELETE,
  SHARING_GET,
  SHARING_GET_FILTERS
} from "./constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";

export const setLoading = (status) => ({
  type: SHARING_LOADING,
  payload: status
});

export const create = (data) => dispatch => {
  dispatch(setLoading(true));
  requestCreate(data)
    .then(response => {
      dispatch({
        type: SHARING_ADD,
        payload: response.data.content
      });
      toast("Operation successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SHARING_ERROR));
    });
};

export const update = (id, data) => dispatch => {
  dispatch(setLoading(true));
  requestUpdate(id, data)
    .then(response => {
      dispatch({
        type: SHARING_UPDATE,
        payload: response.data.content
      });
      toast("Operation successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SHARING_ERROR));
    });
};

export const remove = (id) => dispatch => {
  dispatch(setLoading(true));
  requestDelete(id)
    .then(response => {
      dispatch({
        type: SHARING_DELETE,
        payload: response.data.content
      });
      toast("Operation successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SHARING_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("sharing/account", page, size, sort, filters)
    .then((response) => {
      dispatch({
        type: SHARING_GET,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SHARING_ERROR));
    });
};

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("sharing/account")
    .then(response => {
      dispatch({
        type: SHARING_GET_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SHARING_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/sharing/actions.js